__turbopack_context__.v({
  "active": "k-LvFW_active",
  "content": "k-LvFW_content",
  "contentMobile": "k-LvFW_contentMobile",
  "fadeIn": "k-LvFW_fadeIn",
  "mobileNav": "k-LvFW_mobileNav",
  "mobileNavColumn": "k-LvFW_mobileNavColumn",
  "mobileNavItem": "k-LvFW_mobileNavItem",
  "nav": "k-LvFW_nav",
  "navItem": "k-LvFW_navItem",
  "root": "k-LvFW_root",
  "secondaryNavMobileExpand": "k-LvFW_secondaryNavMobileExpand",
  "sectionTitleVisible": "k-LvFW_sectionTitleVisible",
});
